import React from 'react'
import { useNavigate } from 'react-router-dom'

import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags'
import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import { ToolbarButton } from '@fourthwall/components'
import type { ToolbarButtonProps } from '@fourthwall/components/dist/common/ToolbarButton/types'
import { CommentIcon } from '@fourthwall/icons'
import { routing } from '@utils/routing'

import { useDirectMessagesWidgetQuery } from './queries/useDirectMessagesWidgetQuery'

type MessagesWidgetProps = {
  iconSize?: ToolbarButtonProps['iconSize']
}

export const MessagesWidget = ({ iconSize = 18 }: MessagesWidgetProps) => {
  const navigate = useNavigate()
  const { hasPermission } = useDashboardPermissions()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()

  const enabled =
    dashboardFeatureFlags.membershipsMessages.enabled && hasPermission('memberships.messages')

  const { directMessagesWidgetQuery } = useDirectMessagesWidgetQuery([], {
    refetchInterval: (data) => (data && data.unreadConversationsCount ? 5_000 : 60_000),
    enabled,
  })

  if (!enabled) return null

  return (
    <ToolbarButton
      label="Messages"
      icon={CommentIcon}
      activityIndicator={!!directMessagesWidgetQuery.data?.unreadConversationsCount}
      activityIndicatorCount={directMessagesWidgetQuery.data?.unreadConversationsCount}
      iconSize={iconSize}
      onClick={() => navigate(routing.memberships.messages.self)}
    />
  )
}
